import { theme } from '@services/theme.service/theme';
import { clamp, rem } from '@visiba/std';
import { Fragment, ReactNode } from 'react';
import styled from 'styled-components';

const elements = {
	ellipse: styled.div`
		min-width: ${rem(17)};
		height: ${rem(17)};
		padding: 0 ${rem(5)};
		font-weight: 600;
		font-size: ${rem(12)};
		line-height: ${rem(17)};
		display: flex;
		align-items: center;
		justify-content: center;
		background: ${theme.accentColor};
		color: ${theme.textOnBackground2};
		border-radius: ${rem(17 / 2)};

		.adjustText {
			position: relative;
			top: -${rem(0.5)};
		}

		.plus {
			position: relative;
			top: -${rem(1)};
			left: -${rem(1)};
			width: ${rem(5)};
		}
	`,
};

interface BadgeProps {
	children: ReactNode;
}

export function Badge({ children }: BadgeProps): JSX.Element {
	return <elements.ellipse>{children}</elements.ellipse>;
}

interface BadgeAmountProps {
	value: number;
}

function BadgeAmount({ value }: BadgeAmountProps): JSX.Element {
	const displayAmount = clamp(value, [0, 99]);

	return (
		<Fragment>
			<span className='adjustText' data-testid='badge-text'>
				{displayAmount}
			</span>
			{value >= 100 ? <span className='plus'>+</span> : null}
		</Fragment>
	);
}

Badge.Amount = BadgeAmount;

interface BadgeTextProps {
	value: string;
}

function BadgeText({ value }: BadgeTextProps): JSX.Element {
	return (
		<span className='adjustText' data-testid='badge-text'>
			{value}
		</span>
	);
}

Badge.Text = BadgeText;
